module.exports = __webpack_public_path__ + "img/thumb-006.d9a82d0c.png";